__turbopack_context__.v({
  "article": "EncyclopediaArticle-module-scss-module__wvFqHW__article",
  "author-contact": "EncyclopediaArticle-module-scss-module__wvFqHW__author-contact",
  "more-articles": "EncyclopediaArticle-module-scss-module__wvFqHW__more-articles",
});
